import { createContext, useContext, useEffect } from "react";

export const THEMES = {
  blue: {
    name: "blue",
    label: "Default",
    accent: "#38bdf8",
    accentBg: "rgba(56,189,248,0.1)",
    accentBorder: "rgba(56,189,248,0.3)",
    accentGlow: "rgba(56,189,248,0.45)",
    accentDark: "rgba(56,189,248,0.07)",
  },
  green: {
    name: "green",
    label: "Green",
    accent: "#22c55e",
    accentBg: "rgba(34,197,94,0.1)",
    accentBorder: "rgba(34,197,94,0.3)",
    accentGlow: "rgba(34,197,94,0.45)",
    accentDark: "rgba(34,197,94,0.07)",
  },
  halloween: {
    name: "halloween",
    label: "Halloween",
    accent: "#f97316",
    accentBg: "rgba(249,115,22,0.1)",
    accentBorder: "rgba(249,115,22,0.3)",
    accentGlow: "rgba(249,115,22,0.45)",
    accentDark: "rgba(249,115,22,0.07)",
  },
  kawaii: {
    name: "kawaii",
    label: "Kawaii",
    accent: "#f472b6",
    accentBg: "rgba(244,114,182,0.1)",
    accentBorder: "rgba(244,114,182,0.3)",
    accentGlow: "rgba(244,114,182,0.45)",
    accentDark: "rgba(244,114,182,0.07)",
  },
  mono: {
    name: "mono",
    label: "Mono",
    accent: "#e5e5e5",
    accentBg: "rgba(229,229,229,0.07)",
    accentBorder: "rgba(229,229,229,0.18)",
    accentGlow: "rgba(229,229,229,0.28)",
    accentDark: "rgba(229,229,229,0.04)",
  },
};

export const ThemeContext = createContext(THEMES.mono);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ theme = "mono", children }) {
  const t = THEMES[theme] || THEMES.mono;
  // Accent CSS variables for every page (static style objects read these)
  useEffect(() => {
    const root = document.documentElement.style;
    const hex = t.accent.replace("#", "");
    root.setProperty("--rbx-accent", t.accent);
    root.setProperty("--rbx-accent-glow", t.accentGlow);
    root.setProperty("--rbx-accent-border", t.accentBorder);
    root.setProperty("--rbx-accent-rgb", [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16)).join(","));
  }, [t]);
  return (
    <ThemeContext.Provider value={t}>
      {children}
    </ThemeContext.Provider>
  );
}
